/**
 * Requires
 */

import $ from 'jquery'
import 'slick-carousel'

import { revalidate as revalidateLazyload } from './lazyload'

/**
 * Variables
 */

const carouselSelector = '[data-gallery]:not([data-gallery-inited])'
const previous =
  '<button type="button" data-role="none" class="slide-control previous" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg></button>'
const next =
  '<button type="button" data-role="none" class="slide-control next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg></button>'

/**
 * Initialisation
 */

const defaultOptions = {
  slidesToShow: 1,
  speed: 300,
  arrows: true,
  prevArrow: previous,
  nextArrow: next,
  easing: 'easeOutCubic',
  swipeToSlide: true,
  infinite: true,
  centerMode: false,
}

const galleryOptions = {
  variableWidth: true,
  slidesToShow: 1,
  responsive: [
    {
      breakpoint: 760,
      settings: {
        variableWidth: false,
        adaptiveHeight: true,
      },
    },
  ],
}

const activityOptions = {
  infinite: false,
  variableWidth: false,
  adaptiveHeight: true,
  slidesToShow: 5, // min-width 1680
  centerMode: false,
  responsive: [
    {
      breakpoint: 1679,
      settings: {
        slidesToShow: 4,
        variableWidth: false,
        adaptiveHeight: true,
      },
    },
    {
      breakpoint: 1279,
      settings: {
        slidesToShow: 3,
        variableWidth: false,
        adaptiveHeight: true,
      },
    },
    {
      breakpoint: 639,
      settings: {
        slidesToShow: 2,
        variableWidth: false,
        adaptiveHeight: true,
      },
    },
    {
      breakpoint: 439,
      settings: {
        slidesToShow: 1,
        variableWidth: false,
        adaptiveHeight: true,
      },
    },
  ],
}

export function init() {
  const $carousels = $(carouselSelector)

  $carousels.each((i, elem) => {
    const $carousel = $(elem)

    // console.log('is activities', $carousel[0].hasAttribute('data-activities-gallery'));

    const isActivities = $carousel[0].hasAttribute('data-activities-gallery')

    const carouselSettings = Object.assign({}, defaultOptions, isActivities ? activityOptions : galleryOptions)

    $(elem).slick(carouselSettings)

    $(elem).on('afterChange', () => revalidateLazyload())

    $(elem).attr('data-gallery-inited', '')
  })

  $carousels.on('click', '.slick-slide', function (event) {
    const $slick = $(event.delegateTarget)
    const $slide = $(event.currentTarget)

    if (!$slide.is('.slick-active')) {
      $slick.slick('slickGoTo', $slide.index())
    }
  })

  const iOS = /iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
  if (iOS) $('.header-slides-fullscreen .page-header .media').height($(window).height() - $('header.header').height())
}
